import { Alert, Button, Container, FormField, Grid, Input, Link, Popover, Select, SelectProps, StatusIndicator, Table } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import Pagination from '@cloudscape-design/components/pagination';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import React, { useEffect, useState } from 'react';
import { CustomAppLayout } from '../../layout';
const _preserve = React.version;

//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { mdiAlert, mdiDeleteOutline, mdiFileExcel } from '@mdi/js';
import Icon from '@mdi/react';
import * as XLSX from "xlsx";
import Confirm from '../../../../components/extras/Confirm';
import Favorites from '../../../../components/extras/Favorites';
import SelectEquipment from '../../../../components/selects/selectEquipment';
import SelectPaging from '../../../../components/selects/selectPaging';
import SelectUser from '../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../resources/types';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getEquipment, getUrlVersion, setData, setLoading, setParameters } from '../../../commons/functions';
import { useGlobalState } from '../../../context/GlobalStateContext';

export const MasterHangars = () => {
    const { data, menu, parameters } = useGlobalState();
    interface ItemHangarUsers {
        idUser: number;
        idHangarMember: number;
        price: number;
        displayName: string;
    }

    type ItemHangar = {
        idHangar: number;
        listPrice: number;
        rent: number;
        group: string;
        registration: string;
        hangar: string;
        hangarType: string;
        hangarNumber: string;
        idEquipment: number;
        usersCount: number;
        televigilancia: number;
        users: ItemHangarUsers[];
    }

    const hangarTypes: SelectProps.Option[] = [
        { value: '', label: 'Todos' },
        { value: 'H', label: 'Hangar' },
        { value: 'T', label: 'Techado' },
        { value: 'L', label: 'Losa' },
        { value: 'P', label: 'Pasto' },
    ];



    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");

            if (id) handleGetHangar(parseInt(id));
            else handleGetHangars();
        };
        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);



    const [hangar, setHangar] = useState<ItemHangar | undefined>();
    const [hangars, setHangars] = useState<ItemHangar[]>([]);
    const [hangarUser, setHangarUser] = useState<any>();
    const [hangarType, setHangarType] = useState<SelectProps.Option>(hangarTypes[0]);

    useEffect(() => {
        //handleGetHangars()
    }, []);

    const totalPriceHangar = Number(
        (hangar?.users.reduce((sum, user) => sum + user.price, 0) ?? 0).toFixed(3)
    );
    const handleDeleteHangarist = async (idHangarMember: number) => {

        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/hangars/hangarist/delete',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({ idHangarMember: idHangarMember, idHangar: hangar?.idHangar })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data && data.code === 0) {
                if (data.hangar) {
                    setHangar(data.hangar)
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleUpdateHangar = async () => {

        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/hangars/update',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify(hangar)
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data && data.code === 0) {
                window.location.hash = `#masters/hangars`
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleGetHangar = async (id: number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/hangars/get',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    columns: "idHangar,  isActiveHangar, isDeleteHangar, listPrice, hangar, hangarType, hangarNumber, hangarSubType, rent, idEquipment, televigilancia",
                    idHangar: id
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.hangar) {
                setHangar(data.hangar)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };


    const handleGetHangars = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/hangars/list',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    columns: "idHangar,  isActiveHangar, isDeleteHangar, listPrice, hangar, hangarType, hangarNumber, hangarSubType, rent, idEquipment, televigilancia"
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.hangars) {
                setHangars(data.hangars)
                setHangar(undefined)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    const pageSize = 20;
    const [filterValue, setFilterValue] = useState("");
    const [currentPageIndex, setCurrentPageIndex] = useState(1);



    const filtered: ItemHangar[] = hangars.filter((item) => {

        const normalize = (str: string | undefined | null) =>
            (str || "")
                .toString()
                .toLowerCase()
                .normalize("NFD") // Decomposes accented characters (e.g., 'í' -> 'i' + '◌́')
                .replace(/[\u0300-\u036f]/g, "") // Removes the accent marks
                .replace(/[^a-z0-9]/g, ""); // Removes non-alphanumeric

        const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
        const userNames = (item.users || []).map((u) => u.displayName).join(" ");
        const text = [item.hangar, userNames, item.registration]
            .join(" ")
            .toLowerCase()
            .normalize("NFD") // Decomposes accented characters (e.g., 'í' -> 'i' + '◌́')
            .replace(/[\u0300-\u036f]/g, "") // Removes the accent marks
            .replace(/[^a-z0-9]/g, "");

        const matchesSearch =
            searchWords.length === 0 ||
            searchWords.every((word) =>
                text.includes(normalize(word))
            );

        const matchesType =
            !hangarType || hangarType.value === "" || item.hangarType === hangarType.value;

        return matchesSearch && matchesType;
    });

    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);
    useEffect(() => {
        setCurrentPageIndex(1);
    }, [filterValue, hangarType]);

    const exportToExcel = () => {
        const exportData = filtered.map(h => ({
            ...h,
            users: (h.users || []).map(u => u.displayName).join(", ")
        }));
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Hangars");
        XLSX.writeFile(wb, "hangars.xlsx");
    };
    // Initialize state with those IDs checked
    const equipment = getEquipment(hangar?.idEquipment || 0, data)
    return (
        <CustomAppLayout
            toolsHide


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    {hangar && (
                        <SpaceBetween direction="vertical" size="l">

                            <Header
                                variant="h2"
                                description={
                                    hangar?.idHangar === 0
                                        ? "Crear nuevo hangar"
                                        : `ID ${hangar?.idHangar}`
                                }
                                actions={
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button
                                            variant='link'
                                            onClick={() => {
                                                if (hangar.idHangar === 0) {
                                                    handleGetHangars();
                                                }
                                                window.location.hash = "#masters/hangars"

                                            }}>Volver a la lista</Button>
                                        <Favorites />
                                    </SpaceBetween>
                                }>
                                {`Hangar ${hangar?.hangar}`}
                            </Header>

                            <Grid gridDefinition={[
                                { colspan: { default: 3, s: 6 } },
                                { colspan: { default: 3, s: 6 } },
                                { colspan: { default: 3, s: 6 } },
                                { colspan: { default: 3, s: 6 } },

                            ]}>
                                <div>
                                    <FormField label={"Hangar"}>
                                        <Input value={hangar?.hangar || ""}
                                            onChange={(detail) => {
                                                if (hangar) { setHangar({ ...hangar, hangar: detail.detail.value }) }

                                            }}
                                        />
                                    </FormField>
                                </div>
                                <div>
                                    <FormField label={"Precio lista"}>
                                        <Input type='number' value={hangar?.listPrice.toString() || ""}
                                            onChange={(detail) => {
                                                if (hangar) { setHangar({ ...hangar, listPrice: Number(detail.detail.value) }) }
                                            }} />
                                    </FormField>
                                </div>
                                <div>
                                    <FormField label={"Tipo hangar"}>

                                        <Select options={hangarTypes}
                                            selectedOption={
                                                hangarTypes.find((opt) => opt.value === hangar?.hangarType) || hangarTypes[0]
                                            }
                                            onChange={({ detail }) => {
                                                //setHangarType(detail.selectedOption);
                                                if (hangar) { setHangar({ ...hangar, hangarType: detail.selectedOption.value || '' }) }
                                            }} />
                                    </FormField>
                                </div>
                                <div>
                                    <FormField label={"Televigilancia"}>
                                        <Input type='number' value={hangar?.televigilancia.toString() || ""}
                                            onChange={(detail) => {
                                                if (hangar) { setHangar({ ...hangar, televigilancia: Number(detail.detail.value) }) }
                                            }} />
                                    </FormField>
                                </div>
                                <div>
                                    <FormField label={"Aeronave"}>
                                        <SelectEquipment value={hangar?.idEquipment || 0}
                                            onConfirm={(equipment) => {
                                                if (!hangar) return
                                                if (!equipment) {
                                                    setHangar({ ...hangar, idEquipment: 0 })
                                                    return
                                                }
                                                setHangar({ ...hangar, idEquipment: Number(equipment.idEquipment) })
                                            }}

                                        />
                                    </FormField>
                                </div>
                                <div>
                                    <FormField label={<div style={{ color: "white" }}>{"·"}</div>}>
                                        <Button variant="primary" onClick={() => handleUpdateHangar()}>{hangar?.idHangar === 0 ? "Crear" : "Guardar"}</Button>
                                    </FormField>
                                </div>

                            </Grid>
                            {equipment && (
                                <FormField label="Aeronave" constraintText={equipment.make}>
                                    {equipment.model}
                                </FormField>
                            )}
                            {hangar && totalPriceHangar !== hangar?.listPrice && (
                                <Alert type="warning">
                                    Precio de lista no condice con totalización por usuario

                                    {totalPriceHangar} {hangar?.listPrice}
                                </Alert>
                            )}
                            <Header variant='h2'>Hangaristas</Header>
                            {hangar && (
                                <Grid gridDefinition={hangar.users.map(() => ({ colspan: 4 }))}>

                                    {hangar?.users.map((user, index) => (
                                        <div key={user.idHangarMember.toString() + "A"}>
                                            <Container
                                                header={
                                                    <Header
                                                        variant="h3"
                                                        actions={
                                                            <Link onClick={() => {
                                                                if (!hangar) return;
                                                                setHangarUser(user);

                                                            }}
                                                            ><Icon path={mdiDeleteOutline} size={1} /></Link>
                                                        }
                                                    >
                                                        {user.displayName}
                                                    </Header>
                                                }
                                            >
                                                <FormField key={user.idHangarMember} label={"Precio"}>
                                                    <Input type='number' value={user.price.toString() || "0"} onChange={(detail) => {
                                                        if (hangar) {

                                                            const updatedUsers = hangar.users.map(u => {
                                                                if (u.idHangarMember === user.idHangarMember) {
                                                                    return { ...u, price: Number(detail.detail.value) };
                                                                }
                                                                return u;
                                                            });
                                                            setHangar({ ...hangar, users: updatedUsers });
                                                        }
                                                    }}
                                                        onBlur={() => {
                                                            {
                                                                if (!hangar) return;
                                                                const updatedUsers = hangar.users.map((u, i) =>
                                                                    i === index ? { ...u, price: parseFloat(u.price.toFixed(3)) } : u
                                                                );
                                                                setHangar({ ...hangar, users: updatedUsers });
                                                            }
                                                        }}

                                                    />
                                                </FormField>
                                            </Container>
                                        </div>
                                    ))}
                                </Grid>
                            )}
                            <FormField label="Agregar Hangarista">
                                <SelectUser onConfirm={(user) => {
                                    if (!hangar) return;
                                    if (user) {
                                        if (hangar.users.find(u => u.idUser === user.idUser)) return;
                                        let usr = ({ idUser: user.idUser, idHangarMember: 0, price: 0, displayName: user.displayName })

                                        setHangar({ ...hangar, users: [...hangar.users, usr] })
                                    }
                                }} />
                            </FormField>
                        </SpaceBetween>
                    )}
                    {!hangar && (
                        <SpaceBetween direction="vertical" size="xs">
                            <Header actions={
                                <SpaceBetween direction="horizontal" size="xs">
                                    {hangar === undefined && (
                                        <Button onClick={() => {
                                            let hg: ItemHangar = { idHangar: 0, listPrice: 0, rent: 0, group: '', registration: '', hangar: '', hangarType: '', hangarNumber: '', idEquipment: 0, usersCount: 0, televigilancia: 0, users: [] }
                                            setHangar(hg);
                                        }
                                        }>Agregar</Button>
                                    )}
                                    <Favorites />
                                </SpaceBetween>
                            }>Hangares</Header>

                            <Table
                                stickyHeader
                                variant="embedded"
                                filter={
                                    <SpaceBetween direction='horizontal' size='xs'>
                                        <Select options={hangarTypes} selectedOption={hangarType} onChange={({ detail }) => {
                                            setHangarType(detail.selectedOption);
                                        }} />
                                        <TextFilter
                                            disabled={filtered.length === 0}
                                            filteringText={filterValue}
                                            filteringPlaceholder="Buscar..."
                                            onChange={({ detail }) => setFilterValue(detail.filteringText)}
                                        />
                                        <Button onClick={exportToExcel} disabled={filtered.length === 0} style={{ root: btnIconForm }}><Icon path={mdiFileExcel} size={1} /></Button>

                                    </SpaceBetween>
                                }

                                pagination={



                                    <SpaceBetween direction="horizontal" size="xs" alignItems="center">

                                        {filtered.length > parameters.pageSize && (
                                            <Pagination
                                                currentPageIndex={currentPageIndex}
                                                pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                                onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                            />
                                        )}

                                        {filtered.length > 0 && (

                                            <SelectPaging onSelect={(pageSize) => {
                                                setCurrentPageIndex(1);
                                                setParameters({ ...parameters, pageSize: pageSize });
                                            }} />
                                        )}
                                    </SpaceBetween>

                                }
                                columnDefinitions={[
                                    {
                                        id: "hangar",
                                        header: "Hangar",
                                        cell: item => <Link onClick={() => {
                                            window.location.hash = `#masters/hangars?id=${item.idHangar}`


                                        }}>{item.hangar}</Link>,
                                    },
                                    {
                                        id: "hangarType",
                                        header: "TIpo",
                                        cell: item => hangarTypes.find(ht => ht.value === item.hangarType)?.label || "",
                                    },
                                    {
                                        id: "equipment",
                                        header: "Matrícula",
                                        cell: item => item.registration || "-----",
                                    },
                                    {
                                        id: "listPrice",
                                        header: "Precio Lista",
                                        cell: item => item.listPrice.toFixed(3),
                                    },
                                    {
                                        id: "listPriceUsers",
                                        header: "Renta",
                                        cell: item => (
                                            <>
                                                {item.rent.toFixed(3)}
                                                {item.listPrice !== item.rent && item.rent > 0 && (
                                                    <Popover triggerType="custom" dismissButton={false}
                                                        key={`PO2${item.idHangar}`}
                                                        header="Warning"
                                                        content="Total users price differs from list price"
                                                    >
                                                        <Icon path={mdiAlert} size={1} color="orange" />
                                                    </Popover>
                                                )}
                                            </>
                                        )
                                    },
                                    {
                                        id: "televigilancia",
                                        header: "Televigilancia",
                                        cell: item => item.televigilancia.toFixed(5),
                                    },
                                    {
                                        id: "users",
                                        header: "Usuarios",
                                        cell: item => {
                                            if (Array.isArray(item?.users) && item.users.length > 0) {
                                                return (
                                                    <Popover triggerType="custom" dismissButton={false}
                                                        key={`PO${item.idHangar}`}
                                                        header="Usuarios"
                                                        content={
                                                            <div key={`HH${item.idHangar}`}>
                                                                {item.users.map((user: ItemHangarUsers, index: number) => (
                                                                    <div key={user.idHangarMember || `${item.idHangar}-${index}`}>{user.displayName}</div>
                                                                ))}
                                                            </div>
                                                        }
                                                    >
                                                        <StatusIndicator type="in-progress" key={`SI${item.idHangar}`}>
                                                            {item.users.length} usuario{item.users.length === 1 ? "" : "s"}
                                                        </StatusIndicator>
                                                    </Popover>
                                                );
                                            }

                                            // If there are no users
                                            return (
                                                <StatusIndicator type="info">
                                                    Desocupado
                                                </StatusIndicator>
                                            );
                                        }
                                    }


                                ]}
                                items={paginated}
                            />
                        </SpaceBetween>
                    )}
                    {!!hangar && (
                        <Confirm
                            show={!!hangarUser}
                            type="danger"
                            header="Eliminar usuario del hangar"
                            warning={`¿Estás seguro de que deseas eliminar a ${hangarUser?.displayName} del hangar ${hangar.hangar}?`}
                            onConfirm={() => {
                                handleDeleteHangarist(hangarUser?.idHangarMember);
                                setHangarUser(null);
                            }}
                            onDismiss={() => setHangarUser(null)} action={'Eliminar'} />
                    )}
                </>
            }

        />
    );
};


